import Masonry from 'masonry-layout';

export default {
    init() {
        var elem = document.querySelector('#network-content');
        if(elem) {
            var msnry = new Masonry(elem, {
                // options
                itemSelector: '.network-item',
                horizontalOrder: true,
                gutter: 20,
                // columnWidth: 200
            });
        }
    }
}